<template>
  <div class="content-wrapper">
    <div class="d-flex align-items-center justify-content-between">
      <app-breadcrumb :page-title="$t('income_statement')"/>
      <div class="mb-4">

<!--        <a href="javascript:void(0)" type="button" v-if="$can('create_invoices')"-->
<!--           class="btn btn-info btn-with-shadow pl-2"-->
<!--           @click="exportAllInvoice">-->
<!--          <app-icon name="download" class="size-20 mr-2"/>-->
<!--          {{ $t('export_all') }}-->
<!--        </a>-->

      </div>
    </div>
    <div class="d-flex justify-content-between" style="display: none !important;">
      <div class="w-100 mb-primary">
        <div class="text-white bg-primary shadow rounded d-flex align-items-center p-4">
          <div class="ml-3">
            <h5 class="mb-0">{{ $t('total_amount') }}</h5>

            <div class="flex-shrink-0">
              {{ numberWithCurrencySymbol(invoiceSummation.total_amount) }}
            </div>

          </div>
        </div>
      </div>

      <div class="w-100 mb-primary mx-4">
        <div class="text-white bg-success shadow rounded d-flex align-items-center p-4">
          <div class="ml-3">
            <h5 class="mb-0">{{ $t('total_paid') }}</h5>
            <div class="flex-shrink-0">
              {{ numberWithCurrencySymbol(invoiceSummation.paid_amount) }}
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 mb-primary">
        <div class="text-white bg-warning shadow rounded d-flex align-items-center p-4">
          <div class="ml-3">
            <h5 class="mb-0">{{ $t('total_due') }}</h5>
            <div class="flex-shrink-0">
              {{ numberWithCurrencySymbol(invoiceSummation.due_amount) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-1"></div>
    <app-table :id="tableId" :options="options" @action="getListAction"/>
  </div>
</template>

<script>
import IncomeInvoiceTableMixin from '../../../Mixins/IncomeInvoiceTableMixin';
import {axiosGet, urlGenerator} from "../../../Helpers/AxiosHelper";
import {MAIL_CHECK_URL, TENANT_MAIL_CHECK_URL} from "../../../Config/ApiUrl";

export default {
  name: 'Index',
  mixins: [IncomeInvoiceTableMixin],
  data() {
    return {
      TENANT_MAIL_CHECK_URL,
      MAIL_CHECK_URL,
      isMailSettingExist: false
    }
  },
  methods: {
    exportAllInvoice() {
      window.location.replace(urlGenerator('tax-invoice-export'))
    },
    checkMailSettings() {
      this.preloader = true;
      const url = this.alias === 'tenant' ? TENANT_MAIL_CHECK_URL : MAIL_CHECK_URL
      axiosGet(url).then(response => {
        this.isMailSettingExist = !!response.data;
      })
    },
    showAlertMessage() {
      this.$toastr.e(this.$t('no_delivery_settings_found'));
    }
  },
  mounted() {
    this.checkMailSettings();
  }
}
</script>
